/**
 * Account creation stays off. Existing accounts may sign in. A brand-new
 * Google or Apple account is deleted and signed out unless the caller is an
 * explicit invite signup. Set REACT_APP_INVITE_ONLY=false to reopen signup.
 */
import firebaseApp from "services/firebase";

export const INVITE_ONLY_SIGNUP_MESSAGE =
  "Sign-ups are by invitation only. Contact your administrator if you have trouble logging in.";

export function isInviteOnlyMode() {
  return process.env.REACT_APP_INVITE_ONLY !== "false";
}

export function isNewOAuthAccount(result) {
  return result?.additionalUserInfo?.isNewUser === true;
}

/**
 * @param {import("firebase/compat/app").auth.UserCredential | null | undefined} result
 * @param {{ allowSignup?: boolean }} [options]
 * @returns {Promise<boolean>} true when the new account was rejected
 */
export async function rejectUninvitedOAuthSignup(result, { allowSignup = false } = {}) {
  if (!isInviteOnlyMode() || allowSignup || !isNewOAuthAccount(result)) {
    return false;
  }

  try {
    if (typeof result.user?.delete === "function") {
      await result.user.delete();
    }
  } catch {
    // The account must not stay signed in if deletion fails.
  }

  if (firebaseApp.auth().currentUser) {
    await firebaseApp.auth().signOut();
  }
  return true;
}
